import { Card } from "@/src/components/cards";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import SearchBar from "@/src/components/searchBar";
import { DocumentTemplate, DocumentTemplateType } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { jsonAbstract, uid } from "@/src/utils/utils";
import { useState } from "react";

function DocumentTemplateChoiceList({
  defaultTemplates,
  onSelect,
  types,
}: {
  defaultTemplates?: DocumentTemplate[] | undefined | null;
  types: DocumentTemplateType[] | undefined | null;
  onSelect: (newValue: DocumentTemplate) => void;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");

  return (
    <div className="c1 gap10">
      {!defaultTemplates?.length && (
        <SearchBar
          placeholder="Rechercher un formulaire..."
          value={searchKey}
          onChange={(newValue) => {
            setSearchKey(newValue || "");
          }}
        ></SearchBar>
      )}
      <FetchableList
        queryKey={["DocumentTemplateChoiceList", searchKey, reload]}
        queryFn={async () => {
          return await apiFetch(
            "documentTemplates",
            "loadMany",
            {
              searchKey,
              types,
            },
            "Erreur lors du chargement des modèles de documents"
          );
        }}
        emptyChild={
          searchKey && (
            <div className="center grid c1 gap10 p20">
              Aucun document disponible
            </div>
          )
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((documentTemplate, index) => {
              if (!documentTemplate) return null;
              return (
                <Card
                  key={uid()}
                  color="blue"
                  title={documentTemplate.name}
                  onClick={async () => {
                    onSelect(jsonAbstract(documentTemplate));
                  }}
                >
                  <div className="c1 gap5 mtop5">
                    {documentTemplate.reference && (
                      <div className="card">
                        Formulaire: {documentTemplate.reference.name}
                      </div>
                    )}
                  </div>
                </Card>
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}

async function openDocumentTemplatePicker({
  onSelect,
}: {
  onSelect: (template: DocumentTemplate) => void;
}) {
  return await openDrawer({
    id: "adminDocumentTemplateChoiceDrawer",
    title: "Choisir un modèle de document",
    content: (
      <DocumentTemplateChoiceList
        types={["standard", "letter"]}
        onSelect={async (template) => {
          onSelect(template);
          closeDrawer("adminDocumentTemplateChoiceDrawer");
        }}
      />
    ),
  });
}

export { DocumentTemplateChoiceList, openDocumentTemplatePicker };
